import { includes } from 'lodash';
import { useEffect, useRef } from 'react';

import { axios } from 'common/axios';
import { toastError } from 'common/toast';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { httpErrorCodeToMessage, ignoredHttpErrorCodes } from './utils';

export const HttpErrorBoundary = ({ children }) => {
  const { logout } = useCurrentUser();
  const isErrorHandledRef = useRef<boolean>(false);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (res) => res,
      (error) => {
        if (!isErrorHandledRef.current) {
          const errorCode = error.response?.status;
          const errorMessage = httpErrorCodeToMessage[errorCode];
          const isIgnored = includes(ignoredHttpErrorCodes, errorCode);

          if (isIgnored) {
            logout();
            toastError(errorMessage);
            isErrorHandledRef.current = true;
            setTimeout(() => (isErrorHandledRef.current = false), 3000);
          }
        }

        throw error;
      },
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  return children;
};
